import React from 'react'
import classNames from 'classnames'

import { Modal } from '@zambezi/sdk/modal'
import modalStyle from '@apiEnabler/ob-common/lib/view/modal.module.css'
import { getClientName } from '@apiEnabler/ob-common/lib/tpps'
import { hasMerchantName } from '@apiEnabler/ob-common/lib/vrp-consents'

import style from './CancelVrpModal.module.scss'

export default function CancelVrpModal({ consent, open, onCancel, onConfirm }) {
  const merchantName = hasMerchantName(consent)
  const displayVrpMerchantClientText = merchantName
    ? `${getClientName(consent)} and ${merchantName}`
    : getClientName(consent)
  return (
    <Modal
      className={`${modalStyle.modal} js-modal`}
      title="Cancel payment permission"
      withBackdrop
      withPadding
      open={open}
      onConfirm={onConfirm}
      onCancel={onCancel}
      renderFooter={(onConfirm, onCancel) => (
        <div
          className={classNames(
            'zb-modal-card-foot-actions',
            style.modalFooter
          )}
        >
          <button
            className="js-confirm-action zb-button zb-button-primary zb-modal-action"
            onClick={onConfirm}
          >
            Cancel payment permission
          </button>
          <button
            className="zb-button-link zb-modal-action js-cancel-action"
            onClick={onCancel}
          >
            Keep permission
          </button>
        </div>
      )}
    >
      <div className={style.content}>
        <p className={style.subHeading}>
          You’re about to cancel permission to {displayVrpMerchantClientText}.
          They will no longer be able to submit any new payments on your behalf.
        </p>
        <p>
          You should contact them to fully understand the implications of
          cancelling the payment permission.
        </p>
        <p>
          If you want to re-connect, you'll have to do so on or via their app or
          website.
        </p>
      </div>
    </Modal>
  )
}
